export const CUSTOMER_CREATION_TYPES = {
  STANDARD: 'STANDARD',
  SELF_ONBOARD: 'SELF_ONBOARD',
  WITHOUT_CUSTOMER: 'WITHOUT_CUSTOMER'

}

export const CARD_EMISSION_TYPE = {
  WITHOUT_CARDS: 'WITHOUT_CARDS',
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL'
}

export const OFFICE_FEATURE_FLAGS_OPTIONS = [
   { code: 'FLEXIBLE_REMUNERATION', hasInfo: false, label: 'manage_office_feature_FLEXIBLE_REMUNERATION', info: '' },
   { code: 'EXPORT_FUNNEL_FEATURE', hasInfo: false, label: 'manage_office_feature_EXPORT_FUNNEL_FEATURE', info: '' },
   { code: 'MULTI_CURRENCIES_FEATURE', hasInfo: false, label: 'manage_office_feature_MULTI_CURRENCIES_FEATURE', info: '' },
   { code: 'WATERMARK', hasInfo: false, label: 'manage_office_feature_WATERMARK', info: '' },
   { code: 'OWNER_INVITE_USER', hasInfo: false, label: 'manage_office_feature_OWNER_INVITE_USER', info: '' },
   { code: 'AUTO_EXCHANGE', hasInfo: true, label: 'manage_office_feature_AUTO_EXCHANGE', info: 'manage_office_feature_tooltip_AUTO_EXCHANGE' },
   { code: 'AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION', hasInfo: true, label: 'manage_office_feature_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION', info: 'manage_office_feature_tooltip_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION' },
   { code: 'DEVOLUIVA', hasInfo: false, label: 'manage_office_feature_DEVOLUIVA', info: '' },
   { code: 'MANUAL_EXPENSES_REIMBURSE', hasInfo: true, label: 'manage_office_feature_MANUAL_EXPENSE_REIMBURSE', info: 'manage_office_feature_tooltip_MANUAL_EXPENSE_REIMBURSE' }
]
export const OFFICE_FEATURE_FLAGS_CODES = {
  FLEXIBLE_REMUNERATION: 'FLEXIBLE_REMUNERATION',
  EXPORT_FUNNEL_FEATURE: 'EXPORT_FUNNEL_FEATURE',
  MULTI_CURRENCIES_FEATURE: 'MULTI_CURRENCIES_FEATURE',
  WATERMARK: 'WATERMARK',
  OWNER_INVITE_USER: 'OWNER_INVITE_USER',
  AUTO_EXCHANGE: 'AUTO_EXCHANGE',
  AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION',
  DEVOLUIVA: 'DEVOLUIVA',
  MANUAL_EXPENSE_REIMBURSE: 'MANUAL_EXPENSE_REIMBURSE'
}
